/*global BASE_URL, console, _, Modernizr*/
/*jshint browser:true, jquery:true, undef:true, multistr: true*/

jQuery( document ).ready( function($) {
    "use strict";

    var browserWindow = $( window ),
        html          = $( this.documentElement ),
        masthead      = $( '#masthead' );

    var _fullyConcreteEl      = $( 'input[type=radio][name=fully_concrete]' ),
        _fullyConcreteOtherEl = $( '#fully_concrete_other_specifications' ),
        _fencedEl             = $( 'input[type=radio][name=fenced]' ),
        _fenceTypeEl          = $( '#fence_type' );

    var _dependentRadioAndSelect = function ( radioEl, dependentEl, dependentValue )
    {
        var _val = $( radioEl ).filter( ':checked' ).val();
        if ( _val ) {
            if ( _val === dependentValue ) {
                dependentEl.closest( '.element-wrapper' ).addClass( 'disabled' );
            } else {
                dependentEl.closest( '.element-wrapper' ).removeClass( 'disabled' );
            }
        }
    };

    _fullyConcreteEl.on( 'change', function () {
        var _val = $( this ).filter( ':checked' ).val();

        // Make the related input text empty
        if ( _val ) {
            _fullyConcreteOtherEl.val( '' );
        }
    });

    _fullyConcreteOtherEl.on( 'input propertychange paste', function () {
        var _val = $( this ).val();
        
        // Make the related radio boxes unchecked
        if ( _val !== '' ) {
            _fullyConcreteEl.filter( ':checked' ).prop( 'checked', false );
        }
    });
    
    _fencedEl.on( 'change', function () {
        _dependentRadioAndSelect( this, _fenceTypeEl, 'No' );
    });

    _fullyConcreteEl.trigger( 'change' );
    _fencedEl.trigger( 'change' );

});
